import React, { useContext, useEffect } from "react";
import { GenericBanner, useDeviceTypes } from "halifax";
import { RouterProps } from "react-router-dom";
import { B2B_PORTAL_BANNER_CONTAINER_ID } from "redmond";
import * as constants from "./constants";
import { ClientContext } from "../../../../App";
import { RewardsBannerConnectorProps } from "./container";
import {
  PATH_AVAILABILITY,
  PATH_HOME,
  PATH_SHOP,
  PATH_BOOK,
  PATH_BOOK_CONFIRMATION,
} from "../../../../utils/paths";
import { useIsTravelApp } from "@capone/common";

export interface IRewardsBannerProps
  extends RewardsBannerConnectorProps,
    RouterProps {}

export const RewardsBanner = (props: IRewardsBannerProps) => {
  const { history, largestValueAccount: account, fetchRewardsAccounts } = props;

  useEffect(() => {
    fetchRewardsAccounts();
  }, []);

  const { matchesMobile } = useDeviceTypes();
  const { sessionInfo, isRewardsDisabled } = useContext(ClientContext);
  const firstName = sessionInfo?.userInfo?.firstName || "";

  const { isTravelApp } = useIsTravelApp();

  const isOnBookPath = [
    PATH_BOOK.slice(0, -1),
    PATH_BOOK,
    PATH_BOOK_CONFIRMATION.slice(0, -1),
    PATH_BOOK_CONFIRMATION,
  ].includes(history.location.pathname);

  if (isRewardsDisabled && isOnBookPath && !isTravelApp) {
    return (
      <GenericBanner
        className="rewards-banner-root"
        content={constants.EXPERIENCES_REWARDS_DISABLED_BANNER_TEXT}
        containerId={B2B_PORTAL_BANNER_CONTAINER_ID}
        isMobile={matchesMobile}
      />
    );
  }

  let contentText = "";

  const {
    earn,
    lastFour = "",
    productDisplayName: productId = "",
    rewardsBalance,
  } = account || {};
  const { currency, currencyDescription } = rewardsBalance || {};
  const {
    carsMultiplier: carsEarnRate = "",
    experiencesMultiplier: experiencesEarnRate = "",
    flightsMultiplier: flightEarnRate = "",
    homesMultiplier: homesEarnRate = "",
    hotelsMultiplier: hotelsEarnRate = "",
  } = earn || {};

  // if there are no earn multipliers, do not display banner text
  if (
    isTravelApp ||
    !account ||
    !account?.earn ||
    ((!carsEarnRate || Number(carsEarnRate) <= 0) &&
      (!experiencesEarnRate || Number(experiencesEarnRate) <= 0) &&
      (!flightEarnRate || Number(flightEarnRate) <= 0) &&
      (!homesEarnRate || Number(homesEarnRate) <= 0) &&
      (!hotelsEarnRate || Number(hotelsEarnRate) <= 0))
  ) {
    return null;
  }

  switch (history.location.pathname) {
    case PATH_HOME.slice(0, -1):
    case PATH_HOME:
      if (!matchesMobile) {
        contentText = constants.HOME_PAGE_BANNER_TEXT({
          firstName,
          carsEarnRate,
          experiencesEarnRate,
          flightEarnRate,
          homesEarnRate,
          hotelsEarnRate,
          productId,
          lastFour,
          currency: currencyDescription || currency,
        });
      }
      // hide the banner on mobile search workflow
      else {
        contentText = "";
      }
      break;
    case PATH_AVAILABILITY.slice(0, -1):
    case PATH_AVAILABILITY:
    case PATH_SHOP:
    case PATH_BOOK:
      contentText = constants.HOME_PAGE_BANNER_TEXT({
        firstName,
        carsEarnRate,
        experiencesEarnRate,
        flightEarnRate,
        homesEarnRate,
        hotelsEarnRate,
        productId,
        lastFour,
        currency: currencyDescription || currency,
      });
      break;
  }

  if (!contentText) {
    return null;
  }

  return (
    <GenericBanner
      className="rewards-banner-root"
      content={contentText}
      containerId={B2B_PORTAL_BANNER_CONTAINER_ID}
      isMobile={matchesMobile}
    />
  );
};
